import { Stack, Text } from '@stitch-fix/mode-react';
import React from 'react';

/**
 * UI that renders when there is an Error
 */
const ErrorUi = () => (
  <Stack
    spacing={3}
    hAlign="center"
    my={5}
    mx={0}
    data-testid="error-container"
  >
    <Text height="standard" family="medium" scale="5">
      Something went wrong - like wearing socks with sandals.
    </Text>

    <Text height="standard" family="medium" scale="5">
      Please go back and try again.
    </Text>
  </Stack>
);

export default ErrorUi;
